// extracted by mini-css-extract-plugin
export default {"root":"ModalAvatar_root__1qiAZ","closeButton":"ModalAvatar_closeButton__hwfp8","image":"ModalAvatar_image__JfTdJ","inner":"ModalAvatar_inner__hbGFi"};